import Vue from 'vue';
import {
    Form,
    RadioGroup,
    Radio,
    Field,
    Icon,
    Button,
    Popup,
    Switch,
    Cell,
    Tag,
    SwipeCell,
    Toast,
    Dialog,
    NoticeBar,
    ImagePreview} from 'vant';
import 'vant/lib/form/style';
import 'vant/lib/radio-group/style';
import 'vant/lib/field/style';
import 'vant/lib/radio/style';
import 'vant/lib/icon/style';
import 'vant/lib/button/style';
import 'vant/lib/popup/style';
import 'vant/lib/switch/style';
import 'vant/lib/cell/style';
import 'vant/lib/tag/style';
import 'vant/lib/swipe-cell/style';
import 'vant/lib/toast/style';
import 'vant/lib/dialog/style';
import 'vant/lib/image-preview/style';
import 'vant/lib/notice-bar/style';

Vue.use(Form);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Tag);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(NoticeBar);
Vue.use(ImagePreview);


